
import React, {
    forwardRef,
    useState
} from 'react';

import {
    useDeleteLandscapeListeningQuery
} from '../hooks/useListeningQueryPersistence.js';

import RIQModal from '../../../components/RIQModal.jsx';
import RIQButton from '../../../components/RIQButton.jsx';

const DeleteListeningQueryButton = forwardRef(function DeleteListeningQueryButton(props, ref) {

    const listeningQuery = props.listeningQuery;
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const {mutate: deleteListeningQuery, isLoading: isDeleting} = useDeleteLandscapeListeningQuery(listeningQuery.id);

    function onDeleteListeningQuery(e) {
        e.stopPropagation();
        setShowConfirmModal(true);
    }

    function onConfirmDelete() {
        deleteListeningQuery();
        setShowConfirmModal(false);
    }

    function onCancelDelete() {
        setShowConfirmModal(false);
    }

    return (
        <>
            <button
                className='tlw-border-none tlw-bg-transparent tlw-px-2.5 tlw-py-0.5 tlw-text-sm tlw-leading-normal tlw-shadow-none'
                onClick={(e) => onDeleteListeningQuery(e)}
                ref={ref}
            >
                <span className='fa fa-fw fa-trash tlw-text-md' />
            </button>
            <RIQModal
                title={
                    <>Are you sure you want to delete {listeningQuery.name}?</>
                }
                showModal={showConfirmModal || isDeleting}
            >
                <div
                    className='tlw-overflow-x-auto'
                >
                    <p
                        className='tlw-p-7.5'
                    >
                        Deleting this search will remove it from your account. This cannot be undone.
                    </p>

                    <div className='tlw-flex tlw-items-end tlw-justify-end tlw-border-0 tlw-border-t tlw-border-solid tlw-border-gray-300 tlw-p-7.5'>
                        <RIQButton
                            className='tlw-mx-4 tlw-px-6 tlw-py-3'
                            onClick={onCancelDelete}
                            disabled={isDeleting}
                        >
                            Cancel
                        </RIQButton>
                        <RIQButton
                            className='tlw-mx-4 tlw-px-6 tlw-py-3'
                            onClick={onConfirmDelete}
                            disabled={isDeleting}
                            variant='danger'
                        >
                            Confirm Delete
                        </RIQButton>
                    </div>
                </div>
            </RIQModal>
        </>

    );
});

export default DeleteListeningQueryButton;
